import $ from 'jquery';

export default function init(container) {
	var $filterTerm = $(container).find('.js-mozaik-manual__filter-term');
	var selectedMainFilterTermID = -1;
	var selectedSecondaryFilterTermID = -1;

	$filterTerm.on('click', function() {
		var $mozaik = $(this).parents('.mozaik');
		var $manualMozaikItem = $mozaik.find(".js-mozaik-manual__item");
		$(this).parents('ul').find(".js-mozaik-manual__filter-term").removeClass("active");
		$(this).addClass("active");

		var $activeMainFilter = $mozaik.find('.js-mozaik-manual__main-filter .js-mozaik-manual__filter-term.active');
		var $activeSecondaryFilter = $mozaik.find('.js-mozaik-manual__secondary-filter .js-mozaik-manual__filter-term.active');

		if ($activeMainFilter.length > 0) {
			selectedMainFilterTermID = parseInt($activeMainFilter.attr("data-term-id"));
		}

		if ($activeSecondaryFilter.length > 0) {
			selectedSecondaryFilterTermID = parseInt($activeSecondaryFilter.attr("data-term-id"));
		}

		$manualMozaikItem.each(function() {
			var terms = JSON.parse($(this).attr('data-term-ids'));

			if ((selectedMainFilterTermID === -1 || terms.indexOf(selectedMainFilterTermID) > -1) &&
				(selectedSecondaryFilterTermID === -1 || terms.indexOf(selectedSecondaryFilterTermID) > -1)) {
				$(this).show();
			} else {
				$(this).hide();
			}
		});
	});
}
